import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './servicios/seguridad';
import { FormsModule } from "@angular/forms";

import { NgxPayPalModule } from 'ngx-paypal';
import { NgxStripeModule } from 'ngx-stripe';
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { UserIdleModule } from 'angular-user-idle';
import { Ng2TelInputModule } from 'ng2-tel-input';

import { APP_ROUTING } from './app.routing';

import { AppComponent } from './app.component';
import { HomeComponent } from './secciones/home/home.component';
import { NosotrosComponent } from './secciones/nosotros/nosotros.component';
import { NoPageComponent } from './secciones/no-page/no-page.component';
import { CitasComponent } from './secciones/citas/citas.component';
import { UbicacionesComponent } from './secciones/ubicaciones/ubicaciones.component';
import { TiendaComponent } from './secciones/tienda/tienda.component';
import { AvisoPrivacidadComponent } from './secciones/aviso-privacidad/aviso-privacidad.component';
import { TerminosCondicionesComponent } from './secciones/terminos-condiciones/terminos-condiciones.component';
import { AccesoComponent } from './secciones/acceso/acceso.component';
import { RegistroComponent } from './secciones/registro/registro.component';
import { RecuperacionComponent } from './secciones/recuperacion/recuperacion.component';
import { NewsletterComponent } from './secciones/newsletter/newsletter.component';
import { ActivacionComponent } from './secciones/activacion/activacion.component';
import { ProductoComponent } from './secciones/producto/producto.component';
import { CarritoComponent } from './secciones/carrito/carrito.component';
import { CambioContrasenaComponent } from './secciones/cambio-contrasena/cambio-contrasena.component';
import { MiCuentaComponent } from './secciones/mi-cuenta/mi-cuenta.component';
import { DetallePedidoComponent } from './secciones/detalle-pedido/detalle-pedido.component';


import { BannerComponent } from './componentes/banner/banner.component';
import { TarjetaProductoComponent } from './componentes/tarjeta-producto/tarjeta-producto.component';
import { SliderComponent } from './componentes/slider/slider.component';
import { ContactoComponent } from './componentes/contacto/contacto.component';
import { PaginadorComponent } from './componentes/paginador/paginador.component';
import { SelectComponent } from './componentes/select/select.component';
import { ItemProductoComponent } from './componentes/item-producto/item-producto.component';
import { ItemDetalleCarritoComponent } from './componentes/item-detalle-carrito/item-detalle-carrito.component';
import { ItemWishListComponent } from './componentes/item-wish-list/item-wish-list.component';

import { SliderDirective } from './directiva/slider.directive';

import { OrderModule } from 'ngx-order-pipe';
import { SafePipe, FilterPipe, ArraySortPipe, GroupByPipe, ReversePipe, DisponiblePipe } from './utilidades/utilidades';

import { AyudaComponent } from './secciones/ayuda/ayuda.component';
import { ContactoFormComponent } from './secciones/contacto-form/contacto-form.component';
import { ComoComprarComponent } from './secciones/como-comprar/como-comprar.component';


@NgModule({
    declarations: [
    AppComponent,
    HomeComponent,
    NoPageComponent,
    NosotrosComponent,
    CitasComponent,
    UbicacionesComponent,
    TiendaComponent,
    AvisoPrivacidadComponent,
    TerminosCondicionesComponent,
    AccesoComponent,
    RegistroComponent,
    NewsletterComponent,
    ActivacionComponent,
    RecuperacionComponent,
    ProductoComponent,
    CarritoComponent,
    ItemDetalleCarritoComponent,
    CambioContrasenaComponent,
    MiCuentaComponent,
    DetallePedidoComponent,
    AyudaComponent,
    ContactoFormComponent,
    ComoComprarComponent,

    BannerComponent,
    SliderComponent,
    TarjetaProductoComponent,
    ContactoComponent,
    PaginadorComponent,
    SelectComponent,
    ItemProductoComponent,
    ItemWishListComponent,


    SliderDirective,


    SafePipe,
    ArraySortPipe,
    FilterPipe,
    GroupByPipe,
    ReversePipe,
    DisponiblePipe
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        APP_ROUTING,
        FormsModule,
        HttpClientModule,
        Ng2TelInputModule,
        NgxPayPalModule,
        OrderModule,
        UserIdleModule.forRoot({idle: 1800, timeout: 60, ping: 60}),
        // UserIdleModule.forRoot({idle: 30, timeout: 10, ping: 10}),
        // NgIdleKeepaliveModule.forRoot(),
        
        NgxStripeModule.forRoot('pk_test_JrhsQfUxOM7Re3KoBVdX0n0v00mldbO92H')
    ],
    providers: [
        Title,
        // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
